import {
  NEXT_PUBLIC_LAUNCH_DARKLY_ID,
  NEXT_PUBLIC_NODE_URL,
  NEXT_PUBLIC_STREAM_KEY,
  NEXT_PUBLIC_STREAM_NOTIFICATIONS_APPID,
  NEXT_PUBLIC_STREAM_NOTIFICATIONS_KEY
} from '@utils/constants';

const config = {
  launchDarklyClientSideID: NEXT_PUBLIC_LAUNCH_DARKLY_ID,
  nodeUrl: NEXT_PUBLIC_NODE_URL,
  perPage: 20,
  streamKey: NEXT_PUBLIC_STREAM_KEY,
  streamNotificationsAppID: NEXT_PUBLIC_STREAM_NOTIFICATIONS_APPID,
  streamNotificationsKey: NEXT_PUBLIC_STREAM_NOTIFICATIONS_KEY,
  superAdminDateTimeFormat: 'DD MMM, YYYY hh:mm A', // This is NOT to be used in company or request context!
};

export default config;
